import {
	allowed,
	allowedInAmTeam,
	allowedInBeta,
	allowedInPreRelease,
	api,
	appData,
	arrayIt,
	arraySetter,
	cookies,
	env,
	events,
	getApiKey,
	hasProp,
	mapTo,
	numbers,
	objects,
	queryArgs,
	requests,
	ruleHelpers,
	storage,
} from 'optinmonster-js-library/src/utils';
import { bulkWatchHandler, getAppData, siteId, siteIds, sort } from 'optinmonster-js-library/src/vue/utils';
import findDiffPosition from './findDiffPosition';
import hasAuthError from './hasAuthError';
import isNoCampaignsError from './isNoCampaignsError';
import * as debug from './debug';
import * as dates from './dates';
import urls from './urls';
import { disableDevCookie } from 'optinmonster-js-library/src/utils/apiKey';
import { isFalsy, isTruthy } from './conditional';

disableDevCookie();

export {
	allowed,
	allowedInAmTeam,
	allowedInBeta,
	allowedInPreRelease,
	api,
	appData,
	arrayIt,
	arraySetter,
	bulkWatchHandler,
	cookies,
	dates,
	debug,
	env,
	events,
	findDiffPosition,
	getApiKey,
	getAppData,
	hasAuthError,
	hasProp,
	isNoCampaignsError,
	isFalsy,
	isTruthy,
	mapTo,
	numbers,
	objects,
	queryArgs,
	requests,
	ruleHelpers,
	siteId,
	siteIds,
	sort,
	storage,
	urls,
};
